/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'

/**
 * Import
 * - Store
 */
import { RootState } from '../../../../../store'

/**
 * Import
 * - Actions
 */
import {
    getQuoteVariation,
    delQuoteVariation,
    createQuoteVariation,
    issueQuoteVariation,
    updateQuoteVariation,
    updateRenewalVariation,
    bindQuoteVariation,
    checkSoftReferral,
    inviteQuoteVariation,
    renewalBindQuoteVariation,
    getRenewalVariation,
    getAllQuoteVariation,
} from '../../../../../actions'

/**
 * Import
 * - Page component
 */
import VariantionContainer from '../components/VariantionContainer'

const mapStateToProps = (state: RootState, props: any) => {
    return {
        step05: state.step05,
        renewalStep05: state.step05Renewals,
        quoteId: props.quoteId,
    }
}

export default connect(
    mapStateToProps,
    {
        getQuoteVariation: getQuoteVariation,
        delQuoteVariation: delQuoteVariation,
        createQuoteVariation: createQuoteVariation,
        getAllQuoteVariation: getAllQuoteVariation,
        issueQuoteVariation: issueQuoteVariation,
        updateQuoteVariation: updateQuoteVariation,
        updateRenewalVariation: updateRenewalVariation,
        bindQuoteVariation: bindQuoteVariation,
        checkSoftReferral: checkSoftReferral,
        inviteQuoteVariation: inviteQuoteVariation,
        renewalBindQuoteVariation: renewalBindQuoteVariation,
        getRenewalVariation: getRenewalVariation,
    }
)(VariantionContainer)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step05m/containers/VariantionContainer.tsx